import { jwtDecode } from 'jwt-decode';
import type { JwtPayload } from '@/types/auth.types';

const EXPIRY_SKEW_SECONDS = 10;

export function decodeToken(token: string): JwtPayload | null {
  try {
    return jwtDecode<JwtPayload>(token);
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string, skewSeconds = EXPIRY_SKEW_SECONDS): boolean {
  const payload = decodeToken(token);

  if (!payload?.exp) {
    return true;
  }

  const nowSeconds = Date.now() / 1000;
  return payload.exp - skewSeconds <= nowSeconds;
}

export function getTokenExpiryDate(token: string): Date | null {
  const payload = decodeToken(token);
  return payload?.exp ? new Date(payload.exp * 1000) : null;
}
